module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_j_normal.ec19a341.png";